<template>
  <div>
    <div
      :id="`comment-${comment.id}`"
      :class="`comment-container custom-panel mt-3
              ${focusedComment === comment.id ? 'comment-focus' : ''}
              ${index % 2 === 1 ? 'custom-panel-grey' : ''}
              `"
      v-for="(comment, index) in comments"
      :key="comment.id"
      @mouseover="setHoverComment(comment.id, true)"
      @mouseleave="setHoverComment(comment.id, false)"
    >
      <b-loading :is-full-page="false" v-model="loadingDelete"></b-loading>
      <a
        v-if="hoverComment === comment.id && canDeleteComment(comment)"
        @click="deleteComment(comment)"
        class="comment-action-icon comment-action-icon-delete has-text-danger"
        title="Delete this comment"
      >
        <b-icon icon="times" />
      </a>
      <a
        v-if="hoverComment === comment.id"
        @click="copy(comment)"
        class="comment-action-icon comment-action-icon-link"
        title="Copy link to comment"
      >
        <b-icon icon="link" />
      </a>
      <div class="comment-avatar mr-4 has-text-centered">
        <username :user="comment.user" />
        <br />
        <forum-date :date="comment.created_at" icon />
      </div>
      <div class="comment-content">
        <div class="content" v-html="comment.text"></div>

        <photo-list
          v-if="comment.photos.length"
          :photos="comment.photos"
          class="mt-2"
        ></photo-list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PhotoList from '@/components/Forum/PhotoList.vue';
import Username from '@/components/Forum/Username.vue';
import { Forum } from '@/services/api';
import { copyToClipboard } from '@/services/utils';
import ForumDate from './ForumDate.vue';

export default {
  name: 'comment-list',
  components: { ForumDate, PhotoList, Username },
  props: {
    comments: Array,
  },
  computed: {
    ...mapGetters('user', ['isAuthenticated', 'profile']),
    ...mapState('forum', ['loadingComments']),
  },
  data() {
    return {
      loadingDelete: false,
      hoverComment: null,
      focusedComment: null,
    };
  },
  mounted() {
    if (this.$route.hash.length) {
      this.focusedComment = parseInt(this.$route.hash.slice(1), 10);
      setTimeout(() => {
        const commentEl = document.getElementById(`comment-${this.focusedComment}`);
        if (commentEl) {
          commentEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  },
  methods: {
    setHoverComment(id, hover) {
      this.hoverComment = hover ? id : null;
    },
    copy(comment) {
      this.focusedComment = comment.id;
      const newPath = `${this.$route.path}?page=${this.$route.query.page || 1}#${comment.id}`;
      const copyUrl = `https://${window.location.host}${newPath}`;
      copyToClipboard(copyUrl);
      this.$buefy.toast.open(`${copyUrl} copied to your clipboard`);
    },
    canDeleteComment(comment) {
      return this.isAuthenticated && comment.user_id === this.profile.id;
    },
    deleteComment(comment) {
      this.$buefy.dialog.confirm({
        title: 'Delete?',
        message: 'Are you sure you want to delete that comment? This action is not revertible.',
        confirmText: 'Yes, delete!',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.loadingDelete = true;

          Forum.deleteComment(comment.id)
            .then(() => {
              this.$emit('deleted');
            })
            .catch((error) => {
              const responseError = error.response.data;

              this.$buefy.dialog.alert({
                title: 'Error',
                message: responseError.message || 'Sorry, something went wrong :( Please try again later...',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
              });
            })
            .finally(() => {
              this.loadingDelete = false;
            });
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.comment-action-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 1rem;

  + .comment-action-icon {
    top: 30px;
  }
}
.comment-container {
  display: flex;
  position: relative;
  padding-right: 35px;

  .comment-avatar {
    min-width: 100px;
    max-width: 100px;
  }

  &.comment-focus {
    box-shadow: rgba(121, 87, 213, 0.7) 1px 1px 12px;
    border: 1px solid #7957d5;
  }
}
</style>
